module.exports = __webpack_public_path__ + "produce-fresh-grass-12.jpg?6ddfee154d3805629e709018cf853e3f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-12.jpg
// module id = 49
// module chunks = 0